import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Headers, Http } from "@angular/http";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ApiEvsService } from "app/common/services/ApiEvs.service";
import { saveAs } from 'file-saver/FileSaver';

@Injectable()
export class WarningAutoService {
  headers: Headers;
  url = environment.qrcode_url;
  constructor(private http: Http, private apiEvsService: ApiEvsService) {
    const token = localStorage.getItem("Access-Token");
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    });
  }

  // lấy danh sách cảnh báo tràn hàng tự động
  getList(body: any = null): Observable<any> {
    return this.http
      .post(`${this.url}/warning`, body, { headers: this.headers })
      .map((res: any) => res.json())
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  // lấy thông tin chi tiết tem
  getDetail(idStamp: string, query: any = null): Observable<any> {
    return this.http
      .get(this.url + "/warning/" + idStamp, {
        headers: this.headers,
        params: query,
      })
      .map((res: any) => {
        return res.json();
      })
      .catch((error: any) => {
        throw this.apiEvsService.checkErr(error);
      });
  }

  // báo cáo đại lý vi phạm
  reportAgency(body: any = null) {
    return this.http
      .put(this.url + "/warning", body, { headers: this.headers })
      .map((res: any) => res.json())
      .catch((err: any) => {
        throw this.apiEvsService.checkErr(err);
      });
  }

  // Export logs
  public getTokenDownloadWarningAuto(query) {
    return this.apiEvsService.getExcel2('/qr_aps/warning/export', query)
  }

  public saveToFileSystem(response, __type, filename) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');

    if (contentDispositionHeader !== null) {
      const parts: string[] = contentDispositionHeader.split(';');
      //const filename = parts[1].split('=')[1];
      const blob = new Blob([response._body], { type: __type });
      console.log(111, blob)
      saveAs(blob, filename);
    } else {
      // handling download condition if content disposition is empty
      const blob = new Blob([response._body], { type: __type });
      console.log(222, blob)

      saveAs(blob, filename);
    }

  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/warning-overflow/services/warning-auto.service.ts